import { axiosCreate } from "../../../../../config";
import { verifyBodyResponse } from "../../../../helpers/verifyBodyResponse";

const CONTRATOR_PATH = 'access/by/invitations/report/detail'

export const getContratorAccessDetail = async ({
    token,
    access_id,
    limit = 5,
    skip = 0,
    date_from,
    date_to,
    sort_by,
    sort_order
}) => {

    try {
        const params = {
            access_id,
            limit,
            skip,
            date_from,
            date_to,
            sort_by,
            sort_order
        }

        const res = await axiosCreate.get(`${CONTRATOR_PATH}`, {
            params,
            timeout: 10000,
            headers: {
                Authorization: `Bearer ${token}`
            }
        })

        return verifyBodyResponse(res, true)
    } catch (error) {
        return verifyBodyResponse(error, false)
    }

}